import type { Node, Relationship, RelationshipWithNodes, Type, TypeStats } from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function getTypeIdsWithCountAndProperties(sourceWorkspaceIds: string[], targetWorkspaceIds: string[]) {
	const response = await axios.get<TypeStats[]>(`${env.apiUrl}/relationships/types`, {
		params: {
			sourceWorkspaceIds,
			targetWorkspaceIds
		}
	})

	return response.data
}

export async function getTypeRelationships(type: string, sourceWorkspaceIds: string[], targetWorkspaceIds: string[]) {
	const response = await axios.get(`${env.apiUrl}/relationships/${type}`, {
		params: {
			sourceWorkspaceIds,
			targetWorkspaceIds
		}
	})

	return response.data as RelationshipWithNodes[]
}

export async function getNodeRelationships(nodeId: string) {
	const response = await axios.get(`${env.apiUrl}/relationships/node/${nodeId}`)

	return response.data as RelationshipWithNodes[]
}

export async function getRelationshipsConflicts(relationships: Relationship[], nodes: Node[]) {
	const response = await axios.post(`${env.apiUrl}/relationships/conflicts`, { relationships, nodes })

	return response.data as RelationshipWithNodes[]
}

export async function createRelationship(relationship: Omit<Relationship, Relationship['id']>) {
	const response = await axios.post(`${env.apiUrl}/relationships`, {
		relationship
	})

	return response.data as RelationshipWithNodes
}

export async function searchType(nodeId: string, type: string) {
	const response = await axios.post(`${env.apiUrl}/relationships/search`, {
		type,
		nodeId
	})

	return response.data as Type[]
}

export async function searchRelationship(nodeId: string, type: string, name: string) {
	const response = await axios.post(`${env.apiUrl}/relationships/search`, {
		type,
		nodeId,
		name
	})

	return response.data as RelationshipWithNodes[]
}

export async function updateRelationship(id: string, relationship: Partial<Relationship>) {
	await axios.put(`${env.apiUrl}/relationships/${id}`, {
		relationship
	})
}

export async function deleteRelationshipProperty(id: string, property: string) {
	await axios.delete(`${env.apiUrl}/relationships/${property}/${id}`)
}

export async function deleteRelationship(id: string) {
	await axios.delete(`${env.apiUrl}/relationships/${id}`)
}
